import { MenuItem } from './menu-item'
import { MenuItemData } from '../menu-item-data'
import { MenuList } from './styled'
import { ReactElement } from 'react'
import { useMenu } from '../hooks/use-menu'

type MenuProps = {
  menuItems: MenuItemData[]
}

export const Menu = ({ menuItems }: MenuProps): ReactElement => {
  const { onMouseLeave, onMouseMove, itemRefs } = useMenu(menuItems)
  return (
    <MenuList role="menu" onMouseLeave={onMouseLeave} onMouseMove={onMouseMove}>
      {menuItems?.map((menuItem, index) => (
        <MenuItem
          ref={el => {
            itemRefs.current[index] = el
          }}
          key={`menu-item-${index}`}
          menuItem={menuItem}
        />
      ))}
    </MenuList>
  )
}
